import type { HTMLAttributes } from "react";

type StatusTone = "neutral" | "info" | "success" | "warning" | "danger";

export function StatusBadge({ className, ...props }: HTMLAttributes<HTMLSpanElement> & { tone?: StatusTone }) {
  const { tone = "neutral", ...spanProps } = props;
  return <span className={["ui-status", `ui-status--${tone}`, className].filter(Boolean).join(" ")} {...spanProps} />;
}
